/**
 * A period-over-period comparison, or a plain note when no prior period is
 * recorded. Nothing stores last month's figures yet, and rendering
 * "↑ 0 pts vs. last month" would assert a measured no-change that never
 * happened.
 */
export function deltaLabel(delta: number | null, unit: string, period: string): string {
  if (delta === null) {
    return 'No prior period yet'
  }
  return `${delta >= 0 ? '↑' : '↓'} ${Math.abs(delta)}${unit} ${period}`
}

/** One figure of a facility in bold strokes, as the admin's facility dialog shows them. */
export function KpiTile({ label, value, sub, accent }: { label: string; value: string; sub: string; accent?: string }) {
  return (
    <div className={`border border-marine/15 bg-white p-4 border-t-4 ${accent ?? 'border-t-marine'}`}>
      <div className="text-[10px] font-bold uppercase tracking-wide text-ink-mid">{label}</div>
      <div className="text-2xl font-black text-ink">{value}</div>
      <div className="text-xs text-ink-mid mt-1">{sub}</div>
    </div>
  )
}
